import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: 'overzicht', loadChildren: 'app/overview/overview.module#OverviewModule' },
  { path: 'editor', loadChildren: 'app/editor/editor.module#EditorModule' },
  { path: 'contact', loadChildren: 'app/contact/contact.module#ManualModule' },
  { path: '', redirectTo: '/overzicht/social', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts